import BaseEntity from './BaseEntity'

const Props = {
  url: undefined,
  description: undefined,
}

class Gallery extends BaseEntity {}

export default function createGallery(params) {
  const attr = Object.assign({}, Props, params)
  return Object.freeze(new Gallery(attr))
}
